"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestClient = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
/**
 * A REST client based on axios.
 *
 * @export
 * @class RestClient
 */
var RestClient = /** @class */ (function () {
    /**
     * Creates an instance of RestClient.
     */
    function RestClient(baseURL) {
        this.client = axios_1.default.create({ baseURL: baseURL });
        this.client.defaults.headers.common["X-Requested-With"] =
            "XMLHttpRequest";
    }
    /**
     * Sets the default authorization header
     * @param value the header value, typically a token
     * @param scheme the header scheme, defaults to "Bearer"
     */
    RestClient.prototype.setAuthorizationHeader = function (value, scheme) {
        if (scheme === void 0) { scheme = "Bearer"; }
        this.client.defaults.headers.common["Authorization"] = scheme + " " + value;
    };
    /**
     * Performs a JSON GET request
     *
     * @template TResponse
     * @param {string} url
     * @returns {Promise<TResponse>}
     * @memberof RestClient
     */
    RestClient.prototype.getJson = function (url) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { data: response.data, status: response.status }];
                }
            });
        });
    };
    /**
     * Performs a JSON POST request
     *
     * @template TResponse
     * @param {string} url
     * @param {*} data
     * @returns {Promise<TResponse>}
     * @memberof RestClient
     */
    RestClient.prototype.postJson = function (url, data) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response, error_1;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.post(url, data, {
                                withCredentials: true
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { data: response.data, status: response.status }];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, this.handleError(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Performs a JSON PUT request
     *
     * @template TResponse
     * @param {string} url
     * @param {*} data
     * @returns {Promise<TResponse>}
     * @memberof RestClient
     */
    RestClient.prototype.putJson = function (url, data) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response, error_2;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.put(url, data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { data: response.data, status: response.status }];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, this.handleError(error_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RestClient.prototype.handleError = function (error) {
        var axiosError = error;
        if (!axiosError || !axiosError.response) {
            throw error;
        }
        var errorResponse = axiosError.response.data;
        errorResponse.status = axiosError.response.status;
        return errorResponse;
    };
    /**
     * Performs a DELETE request
     *
     * @template TResponse
     * @param {string} url
     * @returns {Promise<TResponse>}
     * @memberof RestClient
     */
    RestClient.prototype.delete = function (url) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response, error_3, axiosError;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { data: response.data, status: response.status }];
                    case 2:
                        error_3 = _a.sent();
                        axiosError = error_3;
                        if (!axiosError || !axiosError.response) {
                            throw error_3;
                        }
                        if (typeof axiosError.response.data.errors === "undefined") {
                            throw error_3;
                        }
                        return [2 /*return*/, axiosError.response.data];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Performs an HTML GET request
     *
     * @param {string} url
     * @returns {Promise<string>}
     * @memberof RestClient
     */
    RestClient.prototype.getHtml = function (url) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response, error_4;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.get(url, {
                                responseType: "text",
                                headers: { Accept: "text\\html" }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { data: response.data, status: response.status }];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, this.handleError(error_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return RestClient;
}());
exports.RestClient = RestClient;
//# sourceMappingURL=RestClient.js.map